import { Injectable } from '@angular/core';

import { CacheBucket, HttpCacheManager } from '@ngneat/cashew';
import { v4 as uuidv4 } from 'uuid';

import { CacheBucketIdEnum } from '@services/reports/models/cache-bucket-id.enum';

@Injectable()
export class CacheService {
    private sessionCacheUUID =
        uuidv4() ||
        '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
            (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & ((15 >> +c) / 4))).toString(16),
        );

    constructor(private cacheManager: HttpCacheManager) {}

    public cacheBuckets: Array<{ name: string; bucket: CacheBucket }> = [
        {
            name: CacheBucketIdEnum.DASHBOARD,
            bucket: new CacheBucket(),
        },
    ];
    public set(name, value, options: any) {
        options = {
            path: '/',
            ...options,
        };

        if (Object.keys(options).length && options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

        for (const optionKey of options) {
            updatedCookie += '; ' + optionKey;
            const optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += '=' + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    public get(name) {
        const matches = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    public remove() {
        this.set(name, '', {
            'max-age': -1,
        });
    }

    public getCacheSessionUUID(): string {
        return this.sessionCacheUUID;
    }

    public clearDashboardCache(): void {
        this.cacheManager.delete(
            this.cacheBuckets.find((bucket) => (bucket.name = CacheBucketIdEnum.DASHBOARD)).bucket,
        );
    }

    public clearHttpCache(): void {
        this.cacheBuckets.forEach((item) => item.bucket.clear());
        localStorage.removeItem('httpCache');
        localStorage.removeItem('httpCacheTTL');
        this.cacheManager.clear();
    }
}
